import { accountActionTypes as actions } from "./account.actions";

export const accountReducer = (state, { type, payload }) => {
  switch (type) {
    case actions.LOGIN:
      return {
        ...state,
        access_token: payload,
      };
    case actions.LOGOUT:
      return {
        ...state,
        access_token: payload,
      };
    case actions.ACCOUNT_INFO:
      return {
        ...state,
        accountInfo: payload,
      };
    case actions.ACCOUNT:
      return {
        ...state,
        account: payload,
      };
    case actions.ACCOUNT_CART:
      return {
        ...state,
        accountCart: payload,
      };
    case actions.TOKEN_EXPIRY:
      return {
        ...state,
        tokenExpiry: payload,
      };
    case actions.ELECTRONIC_ENTRIES_SUMMARY:
      return {
        ...state,
        electronicEntriesSummary: payload,
      };
    case actions.ORDER_ID:
      return {
        ...state,
        orderId: payload,
      };
    case actions.AVAILABLE_PROMOS:
      return {
        ...state,
        availablePromos: payload.data || [],
        availablePromosMeta: payload.meta || null,
        availablePromosLoading: false,
        availablePromosError: null,
        availablePromosLanguage: payload.language || null,
      };
    case actions.AVAILABLE_PROMOS_LOADING:
      return {
        ...state,
        availablePromosLoading: payload,
      };
    case actions.AVAILABLE_PROMOS_ERROR:
      return {
        ...state,
        availablePromosError: payload,
        availablePromosLoading: false,
      };
    default:
      return state;
  }
};
